export const RESTRICTION_ACTIONS = {
    PLAY: 3,
    OPEN_APPLICATION: 4
};

export const RESTRICTION_REASONS = {
    SESSION_LIMIT_REACHED: 8
};

export const RESTRICTION_ENTITY_TYPE = {
    SUB_BRAND: 1,
    GAME_TYPE: 2,
    PACKAGE: 3,
    GAME_GROUP: 8,
    GAME_VENDOR: 9,
    CHILDISH_GAME: 10,
    OFFERING: 11
};
